// extracted by mini-css-extract-plugin
export default {"upperContainer":"Footer_upperContainer__xMiis","bottomContainer":"Footer_bottomContainer__CeVFl","icons":"Footer_icons__dd2DV","footerLogo":"Footer_footerLogo__X4UdQ"};